import { ProductVariantActionState } from '../interfaces';

export const doUpdateProductVariantState = (state: ProductVariantActionState, newState: ProductVariantActionState): ProductVariantActionState => ({
    ...state,
    ...newState,
});

export const doUpdatePageLoading = (state: ProductVariantActionState, isPageLoading: boolean): ProductVariantActionState => ({
    ...state,
    isPageLoading,
});
